"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiKitLite = void 0;
const UiKitBase_1 = require("./UiKitBase");
const UiKitFileDrop_1 = require("./UiKitFileDrop");
const UiKitHooks_1 = require("./UiKitHooks");
exports.UiKitLite = {
    ...UiKitBase_1.UiKitBase,
    Form: {
        ...UiKitBase_1.UiKitBase.Form,
        FileDrop: UiKitFileDrop_1.UiKitFileDrop,
    },
    Hook: UiKitHooks_1.Hook,
};
